import React, { useCallback, useEffect, useState } from 'react';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import AppBar from './AppBar';
import { categoriesActions, eventsActions, requestsActions, userActions } from '../../actions';
import { fetchClientVoices } from '../../slices/client-voices-slice';
import { Loading } from '../common/Loading/Loading';
import ScrollToTop from '../common/ScrollToTop';
import WSClient from '../WSClient';
import { RoutesPage } from './RoutesPage';
import { fetchProgramDelayed } from '../../slices/program-slice';
import { history } from '../../history';

// remove user from local storage (if saved by old version of app)
localStorage.removeItem('user');

function App(props) {
    const { logined, initing, getAllCategories, clearRequests, checkSession, getAllEvents } = props;
    const [checkSessionTimer, setCheckSessionTimer] = useState();
    const dispatch = useDispatch();

    const onStorageChanged = useCallback(
        (e) => {
            if (e.key === 'logined' && e.oldValue !== e.newValue) {
                if (checkSessionTimer) clearTimeout(checkSessionTimer);
                setCheckSessionTimer(
                    setTimeout(() => {
                        checkSession();
                        setCheckSessionTimer(null);
                    }, 300)
                );
            }
        },
        [checkSession, checkSessionTimer]
    );

    useEffect(() => {
        getAllCategories();
        dispatch(fetchProgramDelayed());
        getAllEvents();
        dispatch(fetchClientVoices());
        window.addEventListener('storage', onStorageChanged);
        return () => {
            window.removeEventListener('storage', onStorageChanged);
        };
    }, [getAllCategories, getAllEvents, onStorageChanged, dispatch]);

    useEffect(() => {
        if (!logined) {
            clearRequests();
        }
    }, [clearRequests, logined]);

    useEffect(() => {
        console.log('APP START');
        return () => {
            console.log('APP END');
        };
    }, []);

    return (
        <HistoryRouter history={history} basename={process.env.PUBLIC_URL}>
            <div>
                {initing ? (
                    <Loading />
                ) : (
                    <>
                        <AppBar />

                        <ScrollToTop />

                        <RoutesPage />
                    </>
                )}
                <WSClient />
                <ToastContainer />
            </div>
        </HistoryRouter>
    );
}

function mapStateToProps(state) {
    const {
        auth: { logined, initing },
    } = state;
    return { logined, initing };
}

const actionsToProps = {
    getAllCategories: categoriesActions.getAll,
    getAllEvents: eventsActions.getAll,
    clearRequests: requestsActions.clear,
    checkSession: userActions.checkSession,
};

export default connect(mapStateToProps, actionsToProps)(App);
